import script from "./FormSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSheet.vue?vue&type=script&setup=true&lang=js"

import "./FormSheet.vue?vue&type=style&index=0&id=e4bf7ad6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4bf7ad6"]])

export default __exports__